module.exports = __webpack_public_path__ + "img/ing.a76e05d6.png";